export const normalizeEndDate = (value) => {
  if (value === '') {
    return null
  } else {
    return `${value}T23:59:59`
  }
}

export const normalizeStartDate = (value) => {
  if (value === '') {
    return null
  } else {
    return `${value}T00:00:00`
  }
}
